import StyledSvgIconWrapper, { TStyledSvgIconWrapper } from "./wrappers/StyledSvgIconWrapper";

export const BankIcon: React.FC<TStyledSvgIconWrapper> = ({ active = false, monochrome, ...props }) => {
  return (
    <StyledSvgIconWrapper {...props} active={active} width="64px" height="46px" viewBox="0 0 64 46">
      <g clipPath="url(#clip0_260_104)">
        <path
          d="M56.64 43.84H7.27C4.36 43.84 2 41.47 2 38.54V7.3C2 4.38 4.36 2 7.27 2H56.64C59.55 2 61.91 4.37 61.91 7.3V38.55C61.91 41.47 59.55 43.84 56.64 43.84Z"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
        <path
          d="M10.11 15.95H53.91"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
        <path
          d="M10.1 25.92H21.07"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_104">
          <rect width="63.92" height="45.84" fill="white" />
        </clipPath>
      </defs>
    </StyledSvgIconWrapper>
  );
};
